import { render, staticRenderFns } from "./FileViewerDialog.vue?vue&type=template&id=83d912ba&scoped=true"
import script from "./FileViewerDialog.vue?vue&type=script&lang=js"
export * from "./FileViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./FileViewerDialog.vue?vue&type=style&index=0&id=83d912ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d912ba",
  null
  
)

export default component.exports